const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: "full", // full, close, compact, mobile,
    theme: "blue", // light theme so palette tokens resolve to light values
    bgImgURL: "/assets/images/sidebar/sidebar-bg-dark.jpg",
  },
  topbar: {
    show: true,
    fixed: true,
    theme: "blue", // View all valid theme colors inside MatxTheme/themeColors.js
  },
};

export default Layout1Settings;
